import {
  getPromotionConfig,
  updatePromotionConfig as updatePromotionConfigAPI,
} from '@/services/PromotionsService/promotions'
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

const PROMOTION_CONFIG_KEY = ['promotionConfig']

export const usePromotionConfig = () => {
  const queryClient = useQueryClient()

  const {
    data: promotionConfig,
    isLoading,
    isError,
    error,
    refetch: fetchConfig,
  } = useQuery({
    queryKey: PROMOTION_CONFIG_KEY,
    queryFn: async () => {
      const response = await getPromotionConfig()
      // Using mock data instead of API call
      // const response = mockPromotionConfig
      // Parse the promotion config data so that the dropdown values match the expected ids in promotion object
      // const parseConfig = parsePromotionConfig(response.data)
      return response?.data
    },
  })

  const updateConfigMutation = useMutation({
    mutationFn: updatePromotionConfigAPI,
    onSuccess: () => {
      // Invalidate and refetch the promotion config
      queryClient.invalidateQueries({queryKey: PROMOTION_CONFIG_KEY})
    },
  })

  const handleUpdatePromotionConfig = async configData => {
    try {
      const response = await updateConfigMutation.mutateAsync(configData)
      return response
    } catch (error) {
      console.error('Failed to update promotion config:', error)
      throw error
    }
  }

  return {
    promotionConfig: promotionConfig || {},
    isLoadingConfig: isLoading,
    isError,
    isUpdating: updateConfigMutation.isPending || false,
    updateError: updateConfigMutation.error || null,
    error,
    fetchConfig,
    handleUpdatePromotionConfig,
  }
}
